import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import placeListsLayout from '../constants/placeListsLayout';

function GameContainerHeader({ translate, headerLabel, seeAllLink, isSeeAllHidden }) {
  const seeAllClassNames = classNames(placeListsLayout.seeAllClass, { hidden: isSeeAllHidden });

  return (
    <div
      data-testid='game-lists-game-container-header'
      className='container-header games-filter-changer'>
      <h2>
        <NavLink to={seeAllLink}>{headerLabel}</NavLink>
      </h2>
      <NavLink
        data-testid='game-lists-game-container-header-see-all-button'
        to={seeAllLink}
        className={seeAllClassNames}>
        {translate(placeListsLayout.seeAllLinkLabel)}
      </NavLink>
    </div>
  );
}

GameContainerHeader.defaultProps = {
  isSeeAllHidden: false
};

GameContainerHeader.propTypes = {
  translate: PropTypes.func.isRequired,
  headerLabel: PropTypes.string.isRequired,
  seeAllLink: PropTypes.string.isRequired,
  isSeeAllHidden: PropTypes.bool
};

export default GameContainerHeader;
